import React, { useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import Toggle from "../../components/Toggle";
import BusinessName from "../../components/BusinessName";

const Business = () => {
  const location = useLocation();
  const inactiveClass = "text-gray-400";
  const activeClass = "text-primary";
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const navigateTo = (path) => {
    navigate(path);
    setIsDropdownOpen(false);
  };

  const Business = [
    {
      name: "About",
      path: "/settings/business",
    },
    {
      name: "Notification",
      path: "/settings/business/notifications",
    },
    {
      name: "Upload KYC",
      path: "/settings/business/kyc",
      permission: "Upload Document",
    },
    {
      name: "View Business Details",
      path: "/settings/business/view-document",
    },
    // {
    //   name: "Upload PSS/PSSP/PTSP",
    //   path: "/settings/business/pss-update",
    //   permission: "Upload Document",
    // },
    // {
    //   name: "Upload CAC",
    //   path: "/settings/business/upload-cac",
    // },
    // {
    //   name: "Upload Identification Document",
    //   path: "/settings/business/upload-doc",
    // },

    // {
    //   name: "Security",
    //   path: "/settings/business/security",
    // },
    // {
    //   name: "Payment Method",
    //   path: "/settings/business/payments",
    // },
  ];

  return (
    <div className="overflow-y-auto overflow-x-hidden md:overflow-auto md:overflow-y-hidden">
      <div className="flex flex-col md:flex-row md:items-center justify-between">
        <h1 className="text-2xl font-bold text-navy-blue">
          Settings - Business
        </h1>
        <Toggle />
      </div>

      {/* <section className="flex md:justify-end text-xl font-bold pt-4 mb-4 pr-4">
        <span className="md:ml-2">
          <BusinessName />
        </span>
      </section> */}

      <div className="xl:h-[924px] h-auto max-w-80 md:max-w-full bg-white mt-8 rounded-[10px]  md:p-[3rem]">
        <div className="bg-white min-h-screen md:max-w-full max-w-72 xl:h-[828px] rounded-[10px]">
          <div className="border border-gray-200 rounded-t-[10px] p-[1rem]  pl-7">
            <div className="flex flex-col items-start md:flex-row md:items-center gap-[] justify-between ">
              {Business?.map((p, index) => (
                <div key={index} className="relative inline-block text-left">
                  {p.name === "Upload KYC" ? (
                    <>
                      <div
                        className="flex  items-center gap-2"
                        onClick={toggleDropdown}
                      >
                        <button
                          className={` ${
                            location.pathname === p.path
                              ? activeClass
                              : inactiveClass
                          }`}
                        >
                          {p.name}
                        </button>
                        <span className="mt-1 cursor-pointer">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.5 6.75L9 11.25L13.5 6.75"
                              stroke="#464255"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      {isDropdownOpen && (
                        <div className="origin-top-right absolute left-10 right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                          <div
                            className="py-1"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="options-menu"
                          >
                            <a
                              onClick={() =>
                                navigateTo("/settings/business/upload-cac")
                              }
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                            >
                              Upload CAC
                            </a>
                            <a
                              onClick={() =>
                                navigateTo("/settings/business/pss-update")
                              }
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                            >
                              Upload Operating Licenses
                            </a>
                            <a
                              onClick={() =>
                                navigateTo("/settings/business/upload-doc")
                              }
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                            >
                              Upload Identity Document
                            </a>
                            <a
                              onClick={() =>
                                navigateTo(
                                  "/settings/business/upload-proof-of-address"
                                )
                              }
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                            >
                              Upload Proof of Address
                            </a>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <Link
                      to={p.path}
                      className={
                        location.pathname === p.path
                          ? activeClass
                          : inactiveClass
                      }
                    >
                      {p.name}
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="min-h-screen">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

// <div className="">
//   <div className="flex items-center justify-between">
//     <h1 className="text-2xl font-bold text-navy-blue">
//       Settings - Business
//     </h1>
//     <Toggle />
//   </div>
//   <div className=" h-[924px] bg-white mt-8 rounded-[10px] p-[3rem]">
//     <div className="bg-white w-[full] h-[828px] rounded-[10px]">
//       <div className="border border-gray-200 rounded-t-[10px] p-[1rem] pl-7">

//         <div className="flex items-center gap-[] justify-between ">
//           {Business?.map((p, index) => (
//             <Link
//               key={index}
//               to={p.path}
//               className={
//                 location.pathname === p.path ? activeClass : inactiveClass
//               }
//             >
//               {p?.name}
//             </Link>
//           ))}
//         </div>

//       </div>
//       <div>
//         <Outlet />
//       </div>
//     </div>
//   </div>
// </div>

export default Business;
